module.exports = __webpack_public_path__ + "static/accounting-4302c206bf2c326184885d64282d8e5b.png";